(() => {
  const initialized = new WeakSet();

  const setEmbedAutoplay = (iframe, shouldPlay) => {
    const source = iframe.getAttribute('src');
    if (!source) return;

    try {
      const url = new URL(source, window.location.href);
      const nextValue = shouldPlay ? '1' : '0';
      if (url.searchParams.get('autoplay') === nextValue) return;
      url.searchParams.set('autoplay', nextValue);
      iframe.setAttribute('src', url.toString());
    } catch (error) {
      // Keep the supplied embed URL when it cannot be parsed.
    }
  };

  const initSection = (section) => {
    if (!section || initialized.has(section)) return;
    initialized.add(section);

    const buttons = Array.from(section.querySelectorAll('[data-buddy-how-to-use-motion-toggle]'));
    if (!buttons.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let isInView = true;

    const updateButton = (button, isPaused) => {
      button.setAttribute('aria-pressed', String(isPaused));
      button.setAttribute('aria-label', isPaused ? 'Play how-to-use video' : 'Pause how-to-use video');
      button.querySelector('[data-motion-pause-icon]')?.toggleAttribute('hidden', isPaused);
      button.querySelector('[data-motion-play-icon]')?.toggleAttribute('hidden', !isPaused);
    };

    const syncControl = (button) => {
      const media = button.closest('.buddy-lp-how-to-use__media');
      const video = media?.querySelector('video');
      const embed = media?.querySelector('iframe.buddy-lp-how-to-use__external-video');
      const isPaused = button.dataset.buddyMotionPaused === 'true';
      const shouldPlay = !isPaused && isInView && !document.hidden;

      updateButton(button, isPaused);

      if (video) {
        if (!shouldPlay) {
          video.pause();
        } else {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          const promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        }
      }

      if (embed) setEmbedAutoplay(embed, shouldPlay);
    };

    const syncAllMotion = () => buttons.forEach(syncControl);

    buttons.forEach((button) => {
      button.dataset.buddyMotionPaused = String(reducedMotion.matches);
      button.addEventListener('click', () => {
        button.dataset.buddyMotionPaused = String(button.dataset.buddyMotionPaused !== 'true');
        syncControl(button);
      });
    });

    reducedMotion.addEventListener?.('change', (event) => {
      buttons.forEach((button) => {
        button.dataset.buddyMotionPaused = String(event.matches);
      });
      syncAllMotion();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          isInView = entry.isIntersecting;
          syncAllMotion();
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    }

    document.addEventListener('visibilitychange', syncAllMotion);
    syncAllMotion();
  };

  const init = (root = document) => {
    root.querySelectorAll?.('[data-buddy-how-to-use]').forEach(initSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
